import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { fetchGetFormalOffer } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

export function useGetFormalOffer(offerId: string): TFormalOffer {
    const { data } = useQuery({
        queryKey: ['fetchGetFormalOffer', offerId],
        queryFn: () => fetchGetFormalOffer({ offerId }),
        select: (response) => response.data.formal_offer,
        suspense: true
    });

    if (!data) {
        throw new Error(
            `useGetFormalOffer: formal offer not found: ${offerId}`
        );
    }

    return data;
}
